// Create API Token Actions
export const CREATE_TOKEN_REQUEST = 'API_TOKENS_CREATE_REQUEST';
export const CREATE_TOKEN_SUCCESS = 'API_TOKENS_CREATE_SUCCESS';
export const CREATE_TOKEN_FAILURE = 'API_TOKENS_CREATE_FAILURE';

export const createTokenRequest = (tokenData) => ({
  type: CREATE_TOKEN_REQUEST,
  payload: tokenData
});

export const createTokenSuccess = (data) => ({
  type: CREATE_TOKEN_SUCCESS,
  payload: data
});

export const createTokenFailure = (error) => ({
  type: CREATE_TOKEN_FAILURE,
  payload: error
});

// List API Tokens Actions
export const LIST_TOKENS_REQUEST = 'API_TOKENS_LIST_REQUEST';
export const LIST_TOKENS_SUCCESS = 'API_TOKENS_LIST_SUCCESS';
export const LIST_TOKENS_FAILURE = 'API_TOKENS_LIST_FAILURE';

export const listTokensRequest = () => ({
  type: LIST_TOKENS_REQUEST
});

export const listTokensSuccess = (data) => ({
  type: LIST_TOKENS_SUCCESS,
  payload: data
});

export const listTokensFailure = (error) => ({
  type: LIST_TOKENS_FAILURE,
  payload: error
});

// Update (edit) API Token Actions
export const UPDATE_TOKEN_REQUEST = 'API_TOKENS_UPDATE_REQUEST';
export const UPDATE_TOKEN_SUCCESS = 'API_TOKENS_UPDATE_SUCCESS';
export const UPDATE_TOKEN_FAILURE = 'API_TOKENS_UPDATE_FAILURE';

export const updateTokenRequest = (tokenId, changes) => ({
  type: UPDATE_TOKEN_REQUEST,
  payload: { tokenId, changes }
});

export const updateTokenSuccess = (data) => ({
  type: UPDATE_TOKEN_SUCCESS,
  payload: data
});

export const updateTokenFailure = (error) => ({
  type: UPDATE_TOKEN_FAILURE,
  payload: error
});

// Revoke API Token Actions
export const REVOKE_TOKEN_REQUEST = 'API_TOKENS_REVOKE_REQUEST';
export const REVOKE_TOKEN_SUCCESS = 'API_TOKENS_REVOKE_SUCCESS';
export const REVOKE_TOKEN_FAILURE = 'API_TOKENS_REVOKE_FAILURE';

export const revokeTokenRequest = (tokenId) => ({
  type: REVOKE_TOKEN_REQUEST,
  payload: { tokenId }
});

export const revokeTokenSuccess = (data) => ({
  type: REVOKE_TOKEN_SUCCESS,
  payload: data
});

export const revokeTokenFailure = (error) => ({
  type: REVOKE_TOKEN_FAILURE,
  payload: error
});

// Regenerate API Token Actions
export const REGENERATE_TOKEN_REQUEST = 'API_TOKENS_REGENERATE_REQUEST';
export const REGENERATE_TOKEN_SUCCESS = 'API_TOKENS_REGENERATE_SUCCESS';
export const REGENERATE_TOKEN_FAILURE = 'API_TOKENS_REGENERATE_FAILURE';

export const regenerateTokenRequest = (tokenId, newName) => ({
  type: REGENERATE_TOKEN_REQUEST,
  payload: { tokenId, newName }
});

export const regenerateTokenSuccess = (data) => ({
  type: REGENERATE_TOKEN_SUCCESS,
  payload: data
});

export const regenerateTokenFailure = (error) => ({
  type: REGENERATE_TOKEN_FAILURE,
  payload: error
});

// Clear the one-time revealed token (after the user closes the reveal dialog)
export const CLEAR_REVEALED_TOKEN = 'API_TOKENS_CLEAR_REVEALED';

export const clearRevealedToken = () => ({
  type: CLEAR_REVEALED_TOKEN
});

// Clear a lingering error (e.g. when reopening a dialog)
export const CLEAR_TOKENS_ERROR = 'API_TOKENS_CLEAR_ERROR';

export const clearTokensError = () => ({
  type: CLEAR_TOKENS_ERROR
});
